module.exports = __webpack_public_path__ + "img/storyboard-pro-creation.51acc8db.jpg";